/* eslint @typescript-eslint/strict-boolean-expressions: off */

import { useEffect } from "react";

import {
  ExecutionTiersData,
  useGetPerformanceTiers,
} from "shared/SelectPerformance/useGetPerformanceTiers";
import type { ActiveContext } from "shared/ContextSwitcher/store";

export function useGetAvailablePerformanceTiers(
  activeContext: ActiveContext | undefined
) {
  const { data: performanceTiersData, error } =
    useGetPerformanceTiers(activeContext);

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }
  }, [error]);

  return function getAvailablePerformanceTiers(
    datasetId: number | undefined
  ): ExecutionTiersData[] {
    if (performanceTiersData && datasetId) {
      return performanceTiersData[datasetId] || [];
    } else {
      return [];
    }
  };
}
